module.exports = __webpack_public_path__ + "static/sx-5b091a5e14cb96d6993e8677e6aa1883.svg";